<template>
  <div class="html">
    <banner
      :title="title"
      :content="content"
    />
    <div class="introduce">
      <div class="content_A line">
        <div
          v-for="fwjs in introduceList"
          :key="fwjs.id"
          class="content_list"
        >
          <div>
            <img
              :src="fwjs.img"
              alt=""
            >
          </div>
          <div>{{ fwjs.title }}</div>
          <div>{{ fwjs.title2 }}</div>
          <div>{{ fwjs.phone }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'Risk',
  components: {
    banner
  },
  data() {
    return {
      title: '技术支持',
      content: '',
      introduceList: [
        {
          id: 1,
          img: require('@/assets/support/pic1.png'),
          title: '电话咨询',
          title2: '服务时间：7*24小时',
          phone: '4006336933'
        },
        {
          id: 2,
          img: require('@/assets/support/pic2.png'),
          title: '电子邮箱',
          title2: ' 服务时间：周一至周五9:00-18:00',
          phone: 'service@lingchuangtec.com  '
        },
        {
          id: 3,
          img: require('@/assets/support/pic3.png'),
          title: '微信公众号',
          title2: ' 服务时间：7*24小时',
          phone: '微信公众号搜索“灵创科技安全服务”'
        }
      ],

      costList: [
        {
          id: 1,
          title: '全面评估',
          imgUrl: require('@/assets/securityServices/risk1.png'),
          content:
            '对客户信息系统安全的各个方面的当前潜在威胁、弱点和影响进行全面的评估。'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
.line{
    display: flex;
    justify-content: space-between;
}
.content_list div{
    text-align: center;
    font-size: 23px;
}
.content_list{
    width: 33%;

}
img{
    width: 80px;
    height: 80px;
}
</style>
